module.exports = __webpack_public_path__ + "img/little.a73064c5.svg";